import React from 'react';
import { Link } from 'react-router-dom';
import { Activity, ArrowLeft, FileText } from 'lucide-react';
import { FigIcon } from '../components/FigIcon';

const TermsPage = () => {
  return (
    <div className="min-h-screen bg-[#E8E4DC]">
      <header className="fixed top-0 left-0 right-0 z-50 glass">
        <div className="max-w-3xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 text-[#525252] hover:text-[#1A1C19]">
            <ArrowLeft className="w-4 h-4" />
            Home
          </Link>
          <div className="flex items-center gap-2">
            <FigIcon className="w-6 h-6 text-[#2F3E30]" />
          </div>
        </div>
      </header>

      <main className="pt-24 pb-12 px-6">
        <div className="max-w-3xl mx-auto">
          <div className="flex items-center gap-3 mb-8">
            <FileText className="w-8 h-8 text-[#2F3E30]" />
            <h1 className="text-3xl font-bold" style={{ fontFamily: 'Libre Baskerville, serif' }}>TERMS OF SERVICE</h1>
          </div>

          <div className="prose prose-invert prose-sm max-w-none space-y-6 text-[#525252]">
            <p className="text-[#1A1C19]">Last updated: {new Date().toLocaleDateString()}</p>

            <section>
              <h2 className="text-xl font-bold text-[#1A1C19]" style={{ fontFamily: 'Libre Baskerville, serif' }}>1. ACCEPTANCE OF TERMS</h2>
              <p>
                By accessing and using Trajectory, you agree to be bound by these Terms of Service. 
                If you do not agree to these terms, please do not use our service.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#1A1C19]" style={{ fontFamily: 'Libre Baskerville, serif' }}>2. SERVICE DESCRIPTION</h2>
              <p>
                Trajectory is an educational health platform that provides metabolic risk assessment 
                and lifestyle optimization recommendations. Our service includes:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Metabolic risk scoring based on self-reported data</li>
                <li>Personalized lifestyle correction plans</li>
                <li>Progress tracking tools</li>
                <li>Educational content about metabolic health</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#1A1C19]" style={{ fontFamily: 'Libre Baskerville, serif' }}>3. NOT MEDICAL ADVICE</h2>
              <p>
                <strong className="text-[#1A1C19]">IMPORTANT:</strong> Trajectory does not provide medical advice, 
                diagnosis, or treatment. Our scoring algorithm is for educational purposes only. 
                Always consult a qualified healthcare provider for medical concerns.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#1A1C19]" style={{ fontFamily: 'Libre Baskerville, serif' }}>4. USER RESPONSIBILITIES</h2>
              <p>You agree to:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Provide accurate information in questionnaires</li>
                <li>Not use the service as a substitute for professional medical advice</li>
                <li>Maintain the confidentiality of your account</li>
                <li>Use the service only for personal, non-commercial purposes</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#1A1C19]" style={{ fontFamily: 'Libre Baskerville, serif' }}>5. PAYMENTS AND REFUNDS</h2>
              <p>
                Payments are processed securely through Stripe. We offer a 30-day money-back guarantee 
                if you are not satisfied with the service. Subscription plans can be cancelled at any time 
                through your account settings.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#1A1C19]" style={{ fontFamily: 'Libre Baskerville, serif' }}>6. LIMITATION OF LIABILITY</h2>
              <p>
                Trajectory is provided "as is" without warranties of any kind. We are not liable for 
                any health outcomes, decisions made based on our recommendations, or any indirect, 
                incidental, or consequential damages.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#1A1C19]" style={{ fontFamily: 'Libre Baskerville, serif' }}>7. CHANGES TO TERMS</h2>
              <p>
                We may update these terms from time to time. We will notify users of significant changes 
                via email. Continued use after changes constitutes acceptance of the new terms.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#1A1C19]" style={{ fontFamily: 'Libre Baskerville, serif' }}>8. CONTACT</h2>
              <p>
                For questions about these terms, contact: support@trajectory.health
              </p>
            </section>
          </div>
        </div>
      </main>
    </div>
  );
};

export default TermsPage;
